module.exports = __webpack_public_path__ + "static/media/jobs_pipelines_empty.6d79bb91.png";